export function validateEan (val: string | {label: string, value: string} | Array<string | {label: string, value: string}>) {
  const e = Array.isArray(val)
    ? val.map((v) => typeof v === 'object' ? v.value || v.label : v)
    : typeof val === 'object' ? [val.value || val.label] : [val]
  return !e.some(s => s?.match(/[a-zA-Z]/g)) && e.every(s => s.length === 8 || s.length === 13)
}

export default {
  ean: validateEan
}
